import React, { useState, useEffect } from "react";
import { Button, Card, Container, Input, Row, Table } from "reactstrap";
import { toast } from "react-toastify";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import "../../assets/css/custom.css";

// Manage the Responsibility / Status dropdown options of the Checklist Feedback
// report (BRD 6499).
const FeedbackOptions = () => {
  const [options, setOptions] = useState({ responsibility: [], status: [] });
  const [newOption, setNewOption] = useState({ type: "responsibility", name: "" });

  useEffect(() => {
    getOptions();
  }, []);

  function getOptions() {
    taskmanageService.getFeedbackOptions(1).then((response) => {
      if (response && response.status == 200) {
        setOptions(response.data);
      } else {
        toast.error("Unable to load dropdown options.");
      }
    });
  }

  function save(option) {
    if (!option.name || !option.name.trim()) {
      toast.error("Name is required.");
      return;
    }
    taskmanageService.saveFeedbackOption(option).then((response) => {
      if (response && response.status == 200) {
        toast.success(response.data.message);
        setNewOption({ ...newOption, name: "" });
        getOptions();
      } else {
        toast.error((response && response.data && response.data.message) || "Something went wrong!");
      }
    });
  }

  const renderTable = (type, title) => (
    <div className="col-6">
      <h4>{title}</h4>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th>Name</th>
            <th>Order</th>
            <th>Active</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {options[type].map((o) => (
            <tr key={o.id}>
              <td>
                <Input defaultValue={o.name} onBlur={(e) => (o.name = e.target.value)} />
              </td>
              <td style={{ width: "90px" }}>
                <Input type="number" defaultValue={o.sort_order} onBlur={(e) => (o.sort_order = e.target.value)} />
              </td>
              <td>
                <input type="checkbox" defaultChecked={o.is_active == 1} onChange={(e) => (o.is_active = e.target.checked ? 1 : 0)} />
              </td>
              <td>
                <Button size="sm" color="primary" onClick={() => save({ id: o.id, type: o.type, name: o.name, sort_order: o.sort_order, is_active: o.is_active })}>
                  Save
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <h3>Checklist Feedback Dropdown Options</h3>
        <Card className="shadow p-3">
          {options.can_manage ? (
            <Row className="mb-3">
              <div className="col-3">
                <select className="form-control" value={newOption.type} onChange={(e) => setNewOption({ ...newOption, type: e.target.value })}>
                  <option value="responsibility">Responsibility</option>
                  <option value="status">Status</option>
                </select>
              </div>
              <div className="col-4">
                <Input placeholder="Option name" value={newOption.name} onChange={(e) => setNewOption({ ...newOption, name: e.target.value })} />
              </div>
              <div className="col-2">
                <Button color="primary" onClick={() => save(newOption)}>Add</Button>
              </div>
            </Row>
          ) : null}
          <Row>
            {renderTable("responsibility", "Responsibility")}
            {renderTable("status", "Status")}
          </Row>
        </Card>
      </Container>
    </>
  );
};

export default FeedbackOptions;
